import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { STATUS_CODE } from '@kc-console/core';

import type { StatusCode } from '@kc-console/core';
import type { StateCreator } from 'zustand';

export interface ClientStatusState {
  clientStatus: StatusCode;
}

export interface ClientStatusAction {
  setClientStatus: (clientStatus: StatusCode) => void;
}

export type ClientStatusStore = ClientStatusState & ClientStatusAction;

const initialState: ClientStatusState = {
  clientStatus: STATUS_CODE.OK,
};

const createClientStatusSlice: StateCreator<
  ClientStatusStore,
  [['zustand/devtools', never]],
  []
> = set => ({
  ...initialState,
  setClientStatus: clientStatus => {
    // 서버에서는 모듈 스코프 스토어가 요청 간 공유되므로, SSR 중 write는 다른 사용자를 오염시킵니다.
    if (typeof window === 'undefined') return;
    return set({ clientStatus });
  },
});

/**
 * 클라이언트 사이드가 판정한 서비스 앱 status 저장소입니다.
 * @description
 * - 서버가 재시드하는 쿼리 캐시 밖에 두어, 라우트 이동에도 클라이언트 판정을 보존합니다.
 * - 패키지 내부 전용(배럴 미노출) — 병합·소비는 useServiceAppState를 거치세요.
 */
export const useClientStatusStore = create<ClientStatusStore>()(
  devtools(
    (...args) => ({
      ...createClientStatusSlice(...args),
    }),
    {
      name: 'ClientStatusStore',
    },
  ),
);
